/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BaseUserWithType } from '../models/BaseUserWithType';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class ExternalService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Get User Data On Email
     * Get user data based on an email address.
     *
     * Required:
     *
     * - An api-key that is passed in the header of the request.
     *
     * Args:
     *
     * - `email`: The email address of the user that you want to retrieve data from.
     *
     * Returns:
     *
     * - The user data that is associated with the given email address.
     * @param emailAddress
     * @returns BaseUserWithType Successful Response
     * @throws ApiError
     */
    public getExternalGetUserDataOnEmail(
        emailAddress: string,
    ): CancelablePromise<BaseUserWithType> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/external/user_data/email',
            query: {
                'email_address': emailAddress,
            },
            errors: {
                404: `Not found`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get User Data On Phonenumber
     * Get user data based on a phone number.
     *
     * Required:
     *
     * - An api-key that is passed in the header of the request.
     *
     * Args:
     *
     * - `phone_number`: The phone number of the user that you want to retrieve data from.
     *
     * Returns:
     *
     * - The user data that is associated with the given phone number.
     * @param phoneNumber
     * @returns BaseUserWithType Successful Response
     * @throws ApiError
     */
    public getExternalGetUserDataOnPhonenumber(
        phoneNumber: string,
    ): CancelablePromise<BaseUserWithType> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/external/user_data/phone_number',
            query: {
                'phone_number': phoneNumber,
            },
            errors: {
                404: `Not found`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get User Data On Email
     * Get user data based on an email address.
     *
     * Required:
     *
     * - An api-key that is passed in the header of the request.
     *
     * Args:
     *
     * - `email`: The email address of the user that you want to retrieve data from.
     *
     * Returns:
     *
     * - The user data that is associated with the given email address.
     * @param emailAddress
     * @returns BaseUserWithType Successful Response
     * @throws ApiError
     */
    public getExternalGetUserDataOnEmailVLatest(
        emailAddress: string,
    ): CancelablePromise<BaseUserWithType> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/latest/external/user_data/email',
            query: {
                'email_address': emailAddress,
            },
            errors: {
                404: `Not found`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get User Data On Phonenumber
     * Get user data based on a phone number.
     *
     * Required:
     *
     * - An api-key that is passed in the header of the request.
     *
     * Args:
     *
     * - `phone_number`: The phone number of the user that you want to retrieve data from.
     *
     * Returns:
     *
     * - The user data that is associated with the given phone number.
     * @param phoneNumber
     * @returns BaseUserWithType Successful Response
     * @throws ApiError
     */
    public getExternalGetUserDataOnPhonenumberVLatest(
        phoneNumber: string,
    ): CancelablePromise<BaseUserWithType> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/latest/external/user_data/phone_number',
            query: {
                'phone_number': phoneNumber,
            },
            errors: {
                404: `Not found`,
                422: `Validation Error`,
            },
        });
    }
}
